Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "eventlink2043067688",
  {"link":"eventlink2043067688--link","primaryButton":"eventlink2043067688--primaryButton","secondaryButton":"eventlink2043067688--secondaryButton","mobile":"eventlink2043067688--mobile","root":"eventlink2043067688--root"},
  "",
  8,
  "eventlink2043067688"
);

